import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";

/* 1:1 with discordforge.org CustomSelect.tsx badge:
 *   px-2 py-0.5 rounded-md text-[9px] font-black uppercase tracking-wider
 *   border bg-orange-500/15 text-orange-400 border-orange-500/30
 * Other surfaces (neutral/amber/green/red) follow the same recipe. */
export type BadgeVariant = "accent" | "neutral" | "amber" | "success" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    variant?: BadgeVariant;
    children?: ReactNode;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
    accent: "bg-orange-500/15 text-orange-400 border-orange-500/30",
    neutral: "bg-white/10 text-zinc-300 border-white/20",
    amber: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    success: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    danger: "bg-red-500/15 text-red-400 border-red-500/30",
};

export function Badge({ variant = "accent", className, children, ...rest }: BadgeProps) {
    return (
        <span
            className={cn(
                "inline-flex shrink-0 items-center gap-1 rounded-md border px-2 py-0.5 text-[9px] font-black uppercase tracking-wider",
                VARIANT_CLASSES[variant],
                className
            )}
            {...rest}
        >
            {children}
        </span>
    );
}
